import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAllowedByRole, isAuthenticated, Role } from 'core/utils/auth';

type Props = {
    children: React.ReactNode;
    allowedRoutes?: Role[];
}

const PrivateRoute = ({ children, allowedRoutes }: Props) => {
    const location = useLocation();
    
    if (!isAuthenticated()) {
        return <Navigate to="/auth/login" state={{ from: location }} replace />;
    }
    
    if (isAuthenticated() && !isAllowedByRole(allowedRoutes)) {
        return <Navigate to="/admin" replace />;
    }
    
    return <>{children}</>;
};

export default PrivateRoute;